import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col full-width search-compact-container" }
const _hoisted_2 = { class: "search-top-container" }
const _hoisted_3 = {
  key: 0,
  class: "search-bottom-container"
}

import SearchResultsPane from 'components/search/SearchResultsPane.vue';
import SearchBookPane from 'components/search/SearchResultDetailsPane.vue';
import {useSearchStore} from 'stores/search-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPaneCompact',
  setup(__props) {

const searchStore = useSearchStore();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SearchResultsPane)
    ]),
    (!_unref(searchStore).isTableModeSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(SearchBookPane)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})